// extracted by mini-css-extract-plugin
export default {"container":"document-card-ad_container__idAlj","inner":"document-card-ad_inner__5LZpZ"};